// HOAD: recomendador de tamanho (altura/peso ou cintura/quadril). Os dados
// vêm de snippets/hoad-tamanho-dados.liquid (emitidos num <script
// type="application/json"> dentro do modal só pro produto atual) — nenhuma
// faixa mora neste arquivo.
(function () {
  if (window.__hoadTamanhoCarregado) return;
  window.__hoadTamanhoCarregado = true;

  var TRANSICAO_MS = 220;
  var OPCAO_TAMANHO_HANDLES = ['tamanho', 'size'];

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function handleize(s) {
    return String(s).toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '')
      .replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }

  // Quais medidas o produto usa vem dos dados (chaves de cada tamanho):
  // altura/peso pra peça que veste por porte, cintura/quadril pra bermuda.
  // `ajuda` só aparece pra quem precisa de instrução de como medir.
  var MEDIDAS = {
    altura: { label: 'Altura', un: 'cm', min: 100, max: 230, ph: '170' },
    peso: { label: 'Peso', un: 'kg', min: 30, max: 250, ph: '65' },
    cintura: { label: 'Cintura', un: 'cm', min: 50, max: 160, ph: '80',
      ajuda: 'Meça na parte mais fina do tronco, logo acima do umbigo.' },
    quadril: { label: 'Quadril', un: 'cm', min: 60, max: 180, ph: '95',
      ajuda: 'Meça na parte mais larga do quadril/glúteo.' }
  };

  function faixaOk(f, medidas) {
    return f && medidas.every(function (m) {
      return Array.isArray(f[m]) && f[m].length === 2 && isFinite(f[m][0]) && isFinite(f[m][1]);
    });
  }

  // Chaves começadas com "_" são configuração, não tamanho (ex.: "_prioridade":
  // "quadril" = na dúvida entre dois tamanhos, essa medida manda).
  function lerDados(modal) {
    var el = modal.querySelector('[data-hoad-tamanho-dados]');
    if (!el) return null;
    var tabela;
    try { tabela = JSON.parse(el.textContent); } catch (e) { return null; }
    var tamanhos = Object.keys(tabela || {}).filter(function (t) { return t.charAt(0) !== '_'; });
    if (!tamanhos.length) return null;
    var medidas = Object.keys(tabela[tamanhos[0]] || {}).filter(function (m) { return MEDIDAS[m]; });
    if (!medidas.length) return null;
    var ordem = tamanhos.filter(function (t) { return faixaOk(tabela[t], medidas); });
    if (!ordem.length) return null;
    var prioridade = medidas.indexOf(tabela._prioridade) > -1 ? tabela._prioridade : null;
    return { tabela: tabela, ordem: ordem, medidas: medidas, prioridade: prioridade };
  }

  // As faixas de tamanhos vizinhos se sobrepõem, então "está dentro da faixa"
  // não basta pra escolher: quem cai fora de tudo ou dentro de duas faixas
  // fica com o tamanho de menor distância fora da faixa e, no empate, com o
  // de centro mais próximo.
  function distFora(v, r) {
    var w = (r[1] - r[0]) || 1;
    return v < r[0] ? (r[0] - v) / w : v > r[1] ? (v - r[1]) / w : 0;
  }
  function distCentro(v, r) {
    var w = (r[1] - r[0]) || 1;
    return Math.abs(v - (r[0] + r[1]) / 2) / w;
  }

  // valores = { medida: numero }. A medida prioritária pesa 3x, então ela
  // desempata quando as outras apontam pra outro tamanho.
  function melhorTamanho(dados, valores, so) {
    var melhor = null;
    dados.ordem.forEach(function (t) {
      var score = 0;
      dados.medidas.forEach(function (m) {
        if (so && m !== so) return;
        var peso = m === dados.prioridade ? 3 : 1;
        var f = dados.tabela[t][m];
        score += peso * (distFora(valores[m], f) * 10 + distCentro(valores[m], f));
      });
      if (!melhor || score < melhor.score) melhor = { tamanho: t, score: score };
    });
    return melhor.tamanho;
  }

  function foraDaTabela(dados, valores) {
    return dados.medidas.some(function (m) {
      var todos = [];
      dados.ordem.forEach(function (t) { todos = todos.concat(dados.tabela[t][m]); });
      return valores[m] < Math.min.apply(null, todos) || valores[m] > Math.max.apply(null, todos);
    });
  }

  function lerNumero(txt) {
    var n = parseFloat(String(txt).trim().replace(',', '.'));
    return isFinite(n) ? n : NaN;
  }

  function silhueta() {
    return '<svg viewBox="0 0 60 120" fill="none" stroke="currentColor" stroke-width="1.6" ' +
      'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" preserveAspectRatio="xMidYMax meet">' +
      '<circle cx="30" cy="12" r="8"/><path d="M17 26h26l2 34H15z"/><path d="M17 28l-6 30M43 28l6 30"/>' +
      '<rect x="17" y="60" width="12" height="54" rx="6"/><rect x="31" y="60" width="12" height="54" rx="6"/></svg>';
  }

  var CHECK = '<svg class="hoad-tamanho__figure-check" viewBox="0 0 16 16" fill="none" stroke="currentColor" ' +
    'stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 8.5l3.2 3L13 4.5"/></svg>';

  function renderFiguras(container, dados, recomendado) {
    var n = dados.ordem.length;
    container.innerHTML = dados.ordem.map(function (t, i) {
      var escala = n > 1 ? 0.8 + 0.32 * (i / (n - 1)) : 1;
      var rec = t === recomendado;
      return '<div class="hoad-tamanho__figure' + (rec ? ' is-recommended' : '') + '" style="--s:' + escala.toFixed(3) + '">' +
        (rec ? CHECK : '') + silhueta() + '<span class="hoad-tamanho__figure-label">' + esc(t) + '</span></div>';
    }).join('');
  }

  function trocarPasso(de, para) {
    de.classList.add('is-out');
    setTimeout(function () {
      de.hidden = true;
      de.classList.remove('is-out');
      para.hidden = false;
      para.classList.add('is-out');
      void para.offsetWidth;
      para.classList.remove('is-out');
    }, TRANSICAO_MS);
  }

  function opcaoDaPagina(tamanho) {
    var escopo = document.querySelector('[id^="ProductInfo-"]') || document;
    var alvo = handleize(tamanho);
    for (var i = 0; i < OPCAO_TAMANHO_HANDLES.length; i++) {
      var fieldset = escopo.querySelector('.product-form__input[data-handle="' + OPCAO_TAMANHO_HANDLES[i] + '"]');
      if (!fieldset) continue;
      var radio = fieldset.querySelector('input[type="radio"][data-handle="' + alvo + '"]');
      if (radio) return radio;
      var opt = fieldset.querySelector('select option[data-handle="' + alvo + '"]');
      if (opt) return opt;
    }
    return null;
  }

  function selecionarNaPagina(tamanho) {
    var alvo = opcaoDaPagina(tamanho);
    if (!alvo) return;
    var destaque;
    if (alvo.tagName === 'OPTION') {
      var select = alvo.parentNode;
      select.value = alvo.value;
      select.dispatchEvent(new Event('change', { bubbles: true }));
      destaque = select;
    } else {
      alvo.click();
      destaque = alvo.nextElementSibling || alvo;
    }
    destaque.classList.remove('hoad-tamanho-pulse');
    void destaque.offsetWidth;
    destaque.classList.add('hoad-tamanho-pulse');
    setTimeout(function () { destaque.classList.remove('hoad-tamanho-pulse'); }, 2000);
  }

  function init(modal) {
    if (modal.__hoadTamanhoInit) return;
    modal.__hoadTamanhoInit = true;

    var dados = lerDados(modal);
    if (!dados) return;

    var form = modal.querySelector('[data-hoad-tamanho-form]');
    var elCampos = modal.querySelector('[data-hoad-tamanho-fields]');
    var elAjuda = modal.querySelector('[data-hoad-tamanho-help]');
    elCampos.innerHTML = dados.medidas.map(function (m) {
      var d = MEDIDAS[m];
      return '<label class="hoad-tamanho__field"><span class="hoad-tamanho__label">' + d.label + '</span>' +
        '<span class="hoad-tamanho__input"><input type="text" inputmode="decimal" name="' + m + '" placeholder="' + d.ph +
        '" autocomplete="off" required><em>' + d.un + '</em></span></label>';
    }).join('');
    var ajudas = dados.medidas.filter(function (m) { return MEDIDAS[m].ajuda; }).map(function (m) {
      return '<strong>' + MEDIDAS[m].label + ':</strong> ' + MEDIDAS[m].ajuda.replace(/^Meça /, 'meça ');
    });
    if (ajudas.length) {
      elAjuda.innerHTML = '<span class="hoad-tamanho__help-title">Como medir</span>' + ajudas.join('<br>');
      elAjuda.hidden = false;
    }
    var resultado = modal.querySelector('[data-step="result"]');
    var erro = modal.querySelector('[data-hoad-tamanho-error]');
    var elTamanho = modal.querySelector('[data-hoad-tamanho-size]');
    var elNota = modal.querySelector('[data-hoad-tamanho-note]');
    var elFiguras = modal.querySelector('[data-hoad-tamanho-figures]');
    var btnSelecionar = modal.querySelector('[data-hoad-tamanho-select]');
    var btnVoltar = modal.querySelector('[data-hoad-tamanho-back]');
    var recomendado = null;

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var valores = {};
      for (var i = 0; i < dados.medidas.length; i++) {
        var m = dados.medidas[i];
        var d = MEDIDAS[m];
        var v = lerNumero(form.elements[m].value);
        // Brasileiro costuma digitar altura em metros ("1,70").
        if (m === 'altura' && v > 0 && v < 3) v = v * 100;
        if (!(v >= d.min && v <= d.max)) {
          erro.textContent = 'Informe ' + (m === 'altura' || m === 'cintura' ? 'uma ' : 'um ') + d.label.toLowerCase() +
            ' entre ' + d.min + ' e ' + d.max + ' ' + d.un + '.';
          erro.hidden = false;
          return;
        }
        valores[m] = v;
      }
      erro.hidden = true;

      recomendado = melhorTamanho(dados, valores);
      elTamanho.textContent = recomendado;
      var nota = '';
      if (foraDaTabela(dados, valores)) {
        nota = 'Suas medidas estão fora da nossa tabela. Este é o tamanho mais próximo, confira o guia de medidas antes de escolher.';
      } else if (dados.prioridade) {
        var outra = dados.medidas.some(function (mm) {
          return mm !== dados.prioridade && melhorTamanho(dados, valores, mm) !== melhorTamanho(dados, valores, dados.prioridade);
        });
        if (outra) nota = 'Suas medidas ficam entre dois tamanhos. Na dúvida, seguimos o ' + MEDIDAS[dados.prioridade].label.toLowerCase() + '.';
      }
      elNota.textContent = nota;
      elNota.hidden = !nota;
      renderFiguras(elFiguras, dados, recomendado);
      btnSelecionar.textContent = 'Selecionar tamanho ' + recomendado;
      btnSelecionar.hidden = !opcaoDaPagina(recomendado);
      trocarPasso(form, resultado);
    });

    btnVoltar.addEventListener('click', function () {
      trocarPasso(resultado, form);
    });

    btnSelecionar.addEventListener('click', function () {
      if (!recomendado) return;
      var fechar = modal.querySelector('[id^="ModalClose-"]');
      if (fechar) fechar.click();
      selecionarNaPagina(recomendado);
    });
  }

  function boot() {
    document.querySelectorAll('[data-hoad-tamanho]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
